<template>
    <footer class="flex min-h-11 w-full items-center justify-between gap-4 border-t border-default px-4 py-2">
        <span class="text-sm leading-4 text-muted">
            © {{ new Date().getFullYear() }}
            <RouterLink class="text-primary" :to="{ name: 'home' }">iiPortal Administracija</RouterLink>,
            {{ $t('footer.all_rights_reserved') }}
        </span>
        <RouterLink :to="{ name: 'home' }" class="flex items-center justify-end">
            <LogoComponent small />
        </RouterLink>
    </footer>
</template>

<script setup lang="ts">
    import { RouterLink } from 'vue-router'

    import LogoComponent from '@/components/LogoComponent.vue'
</script>
